module.exports = __webpack_public_path__ + "media/dashboard/assets/images/channels/youtube-6f9e32ba8209c71da075ce148d57c453.png";